import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../APIHelpers/Responses";
import config from "../../config/config.json";

export const cdiscManagementService = {
  // Form Library
  addNewFormLibrary,
  getFormLibraryData,
  updateFormLibrary,
  softDeleteRestoreFormLibrary,

  // Form Library Template
  addNewFormTemplates,
  getFormTemplatesData,
  updateFormTemplates,
  softDeleteRestoreFormTemplates,

  // Study Form Library
  addNewStudyFormLibrary,
  getStudyFormLibraryData,
  updateStudyFormLibrary,
  softDeleteRestoreStudyFormLibrary,
  getClientFormLibraryForPull,
  pullStudyFormLibrary,

  // Study Form Library Template
  addNewStudyFormTemplates,
  getStudyFormTemplatesData,
  importStudyCDISCFromDataEntry,
  updateStudyFormTemplates,
  softDeleteRestoreStudyFormTemplates,

  // CLookup 
  addNewStudyCDISCCLookUp,
  getStudyCDISCCLookUp,
  updateStudyCDISCCLookUp,
  importStudyCLookUpCSVFile,
  softDeleteRestoreStudyCDISCCLookUps,
  pullStudyCDISCCLookUpData,

  // CMap
  addNewStudyCDISCCMap,
  getStudyCDISCCMap,
  updateStudyCDISCCMap,
  importStudyCMapCSVFile,
  softDeleteRestoreStudyCDISCCMaps,
  pullStudyCDISCCMapData,

  // TMap
  pullStudyCDISCTMapData,
  addNewStudyCDISCTMap,
  updateStudyCDISCTMap,
  importStudyTMapCSVFile,
  softDeleteRestoreStudyCDISCTMaps,
  getStudyCDISCTMap,

  // CLookup 
  addNewCDISCCLookUp,
  getCDISCCLookUp,
  downloadCLookUpTemplate,
  importCLookUpCSVFile,
  updateCDISCCLookUp,
  softDeleteRestoreCDISCCLookUps,

  // CMap
  addNewCDISCCMap,
  getCDISCCMap,
  downloadCMapTemplate,
  importCMapCSVFile,
  updateCDISCCMap,
  softDeleteRestoreCDISCCMaps,
  
  // TMap
  addNewCDISCTMap,
  getCDISCTMap,
  updateCDISCTMap,
  importTMapCSVFile,
  downloadTMapTemplate,
  softDeleteRestoreCDISCTMaps,

  // Data Entry Management
  addNewStudyDataEntry,
  getStudyDataEntry,
  updateStudyDataEntry,
  deleteStudyDataEntry,

  // Lookup Domain
  addNewLookupDomain,
  getLookupDomain,
  updateLookupDomain,
  softDeleteRestoreLookupDomain,

  // Lookup Test
  getDomainsForPullData,
  getVariablesForPullData,
  getFunctionsData,
  getEvaluatorsData,

  // CDISC Trail Design Row
  getCDISCTrailDesignData,
  getCDISCTrailDesignColumnsData,
  importCDISCTrailDataEntry,
  
  addNewCDISCTrailDesignRow,
  getCDISCTrailDesignRow,
  updateCDISCTrailDesignRow,
  deleteCDISCTrailDesignRow,
  
  // CDISC Study Trail Design Row
  addNewCDISCStudyTrailDesignRow,
  getCDISCStudyTrailDesignRow,
  updateCDISCStudyTrailDesignRow,
  deleteCDISCStudyTrailDesignRow,
  pullCDISCStudyTrailDesignRow,
  importStudyCDISCTrailDataEntry,
  
  downloadSDATemplate,
  importSDACSVFile,
  addNewCDISCSDA,
  getCDISCSDA,
  deleteCDISCSDA,
  updateCDISCSDA,

  addNewStudyCDISCSDA,
  getStudyCDISCSDA,
  importStudySDACSVFile,
  updateStudyCDISCSDA,
  deleteStudyCDISCSDA,
  pullStudyCDISCSDA,

  getVersionsForPullData,
  getClassForPullData,
  getSDTMCodeListForPullData,
  getValueLevelVariablesList,
  getWithoutValueLevelVariablesList,

  pullAllSDTMData,
  pullVariableCommentId,
  pullVariableMethodId,
  getVariableCommentIdsForPullData,
  getVariableMethodIdsForPullData,

  addNewDomain,
  getDomainData,
  updateDomains,
  softDeleteRestoreDomain,

  addNewCDISCFinalDomain,
  getCDISCFinalDomain,
  downloadFinalDomainTemplate,
  importStudyFinalDomainCSVFile,
  updateCDISCFinalDomain,
  softDeleteRestoreCDISCFinalDomains,

  addNewCDISCStudyFinalDomain,
  getCDISCStudyFinalDomain,
  updateCDISCStudyFinalDomain,
  softDeleteRestoreCDISCStudyFinalDomains,

  addNewVariableMethodId,
  getVariableMethodIdsData,
  updateVariableMethodIds,
  softDeleteRestoreVariableMethodId,

  addNewVariableCommentId,
  getVariableCommentIdsData,
  updateVariableCommentIds,
  softDeleteRestoreVariableCommentId,

  addNewVariable,
  getVariableData,
  updateVariables,
  softDeleteRestoreVariable,

  addNewValueLevel,
  getValueLevelsData,
  updateValueLevels,
  softDeleteRestoreValueLevel,

  runCDISCFinalCode,
  getStudyCDISCOutputLibraryData,
  deleteStudyCDISCCMapsData
};

// Add New Form Library
async function addNewFormLibrary(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewFormLibrary`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Form Library List
async function getFormLibraryData(status, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getFormLibraryData/${status}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getFormLibraryData/${status}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Update Form Library
async function updateFormLibrary(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateFormLibrary`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Form Library
async function softDeleteRestoreFormLibrary(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreFormLibrary`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New Form Library Template
async function addNewFormTemplates(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewFormTemplates`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Form Library List Template
async function getFormTemplatesData(status, formId, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getFormTemplatesData/${status}/${formId}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getFormTemplatesData/${status}/${formId}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Update Form Library Template
async function updateFormTemplates(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateFormTemplates`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Form Library Template
async function softDeleteRestoreFormTemplates(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreFormTemplates`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New Study Form Library
async function addNewStudyFormLibrary(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyFormLibrary`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Study Form Library List
async function getStudyFormLibraryData(status, studyId, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyFormLibraryData/${status}/${studyId}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyFormLibraryData/${status}/${studyId}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Update Study Form Library
async function updateStudyFormLibrary(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyFormLibrary`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Study Form Library
async function softDeleteRestoreStudyFormLibrary(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyFormLibrary`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Study Form Library List
async function getClientFormLibraryForPull(studyId, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getClientFormLibraryForPull/${studyId}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getClientFormLibraryForPull/${studyId}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Pull Study Form Library
async function pullStudyFormLibrary(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}pullStudyFormLibrary`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New Study Form Library Template
async function addNewStudyFormTemplates(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyFormTemplates`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Study Form Library List Template
async function getStudyFormTemplatesData(status, studyId, formId, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyFormTemplatesData/${status}/${studyId}/${formId}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyFormTemplatesData/${status}/${studyId}/${formId}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

//Import TMap CSV File
async function importStudyCDISCFromDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}importStudyCDISCFromDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Update Study Form Library Template
async function updateStudyFormTemplates(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyFormTemplates`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Study Form Library Template
async function softDeleteRestoreStudyFormTemplates(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyFormTemplates`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New Study Control Terms
async function addNewStudyCDISCCLookUp(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyCDISCCLookUp`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Study Control Terms
async function getStudyCDISCCLookUp(status, studyId, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyCDISCCLookUp/${status}/${studyId}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyCDISCCLookUp/${status}/${studyId}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

//Import CLookup CSV File
async function importStudyCLookUpCSVFile(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}importStudyCLookUpCSVFile`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}


// Update Study Control Terms
async function updateStudyCDISCCLookUp(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyCDISCCLookUp`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Study Control Terms
async function softDeleteRestoreStudyCDISCCLookUps(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyCDISCCLookUps`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Pull Study Control Terms
async function pullStudyCDISCCLookUpData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}pullStudyCDISCCLookUpData`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New Study Control Terms
async function addNewStudyCDISCCMap(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyCDISCCMap`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Study Control Terms
async function getStudyCDISCCMap(status, studyId, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyCDISCCMap/${status}/${studyId}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyCDISCCMap/${status}/${studyId}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

//Import TMap CSV File
async function importStudyCMapCSVFile(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}importStudyCMapCSVFile`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}


// Update Study Control Terms
async function updateStudyCDISCCMap(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyCDISCCMap`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Study Control Terms
async function softDeleteRestoreStudyCDISCCMaps(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyCDISCCMaps`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Pull Study Control Terms
async function pullStudyCDISCCMapData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}pullStudyCDISCCMapData`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New Study Control Terms
async function addNewStudyCDISCTMap(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyCDISCTMap`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Study Control Terms
async function getStudyCDISCTMap(status, studyId, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyCDISCTMap/${status}/${studyId}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyCDISCTMap/${status}/${studyId}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

//Import TMap CSV File
async function importStudyTMapCSVFile(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}importStudyTMapCSVFile`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Update Study Control Terms
async function updateStudyCDISCTMap(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyCDISCTMap`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Study Control Terms
async function softDeleteRestoreStudyCDISCTMaps(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyCDISCTMaps`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Pull Study Control Terms
async function pullStudyCDISCTMapData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}pullStudyCDISCTMapData`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Pull Study Control Terms
async function pullStudyCDISCSDA(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}pullStudyCDISCSDA`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Pull Study Control Terms
async function pullAllSDTMData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}pullAllSDTMData`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Pull Study Control Terms
async function pullVariableCommentId(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}pullVariableCommentId`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Pull Study Control Terms
async function pullVariableMethodId(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}pullVariableMethodId`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New Control Terms
async function addNewCDISCCLookUp(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewCDISCCLookUp`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Control Terms
async function getCDISCCLookUp(status, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getCDISCCLookUp/${status}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getCDISCCLookUp/${status}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

//Import CLookup CSV File
async function importCLookUpCSVFile(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}importCLookUpCSVFile`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Download CLookup Template
async function downloadCLookUpTemplate() {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}downloadCLookUpTemplate`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Update Control Terms
async function updateCDISCCLookUp(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateCDISCCLookUp`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Control Terms
async function softDeleteRestoreCDISCCLookUps(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreCDISCCLookUps`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New Control Terms
async function addNewCDISCCMap(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewCDISCCMap`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Control Terms
async function getCDISCCMap(status, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getCDISCCMap/${status}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getCDISCCMap/${status}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

//Import CMap CSV File
async function importCMapCSVFile(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}importCMapCSVFile`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Download CMap Template
async function downloadCMapTemplate() {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}downloadCMapTemplate`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}


// Update Control Terms
async function updateCDISCCMap(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateCDISCCMap`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Control Terms
async function softDeleteRestoreCDISCCMaps(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreCDISCCMaps`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New Control Terms
async function addNewCDISCTMap(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewCDISCTMap`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Control Terms
async function getCDISCTMap(status, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getCDISCTMap/${status}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getCDISCTMap/${status}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Update Control Terms
async function updateCDISCTMap(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateCDISCTMap`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

//Import TMap CSV File
async function importTMapCSVFile(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}importTMapCSVFile`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Download TMap Template
async function downloadTMapTemplate() {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}downloadTMapTemplate`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Delete Control Terms
async function softDeleteRestoreCDISCTMaps(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreCDISCTMaps`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New Lookup Domain
async function addNewLookupDomain(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewLookupDomain`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Lookup Domain
async function getLookupDomain(status, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getLookupDomain/${status}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getLookupDomain/${status}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Update Lookup Domain
async function updateLookupDomain(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateLookupDomain`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Soft Delete & Restore Lookup Domain
async function softDeleteRestoreLookupDomain(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreLookupDomain`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New Study Data Entry
async function addNewStudyDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Study Data Entry
async function getStudyDataEntry(studyId, formId, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyDataEntry/${studyId}/${formId}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyDataEntry/${studyId}/${formId}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Update Study Data Entry
async function updateStudyDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyDataEntry`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Study Data Entry
async function deleteStudyDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyDataEntry`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Evaluators Data
async function getEvaluatorsData(status) {
  let response;
  response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getEvaluatorsData/${status}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Function Data
async function getFunctionsData(status) {
  let response;
  response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getFunctionsData/${status}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Domains Data
async function getDomainsForPullData(status) {
  let response;
  response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getDomainsForPullData/${status}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Variables Data
async function getVariablesForPullData(status, domainId) {
  let response;
  response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getVariablesForPullData/${status}/${domainId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get CDISC Trail Design Data
async function getCDISCTrailDesignData(status, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getCDISCTrailDesignData/${status}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getCDISCTrailDesignData/${status}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get CDISC Trail Design Data Columns
async function getCDISCTrailDesignColumnsData(status, trailId, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getCDISCTrailDesignColumnsData/${status}/${trailId}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getCDISCTrailDesignColumnsData/${status}/${trailId}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

//Import TMap CSV File
async function importCDISCTrailDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}importCDISCTrailDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New CDISC Trail Design Row
async function addNewCDISCTrailDesignRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewCDISCTrailDesignRow`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get CDISC Trail Design Row
async function getCDISCTrailDesignRow(trailId, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getCDISCTrailDesignRow/${trailId}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getCDISCTrailDesignRow/${trailId}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Update CDISC Trail Design Row
async function updateCDISCTrailDesignRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateCDISCTrailDesignRow`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete CDISC Trail Design Row
async function deleteCDISCTrailDesignRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteCDISCTrailDesignRow`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}


// Add New CDISC Study Trail Design Row
async function addNewCDISCStudyTrailDesignRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewCDISCStudyTrailDesignRow`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get CDISC Study Trail Design Row
async function getCDISCStudyTrailDesignRow(trailId, studyId, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getCDISCStudyTrailDesignRow/${trailId}/${studyId}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getCDISCStudyTrailDesignRow/${trailId}/${studyId}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Update CDISC Study Trail Design Row
async function updateCDISCStudyTrailDesignRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateCDISCStudyTrailDesignRow`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete CDISC Study Trail Design Row
async function deleteCDISCStudyTrailDesignRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteCDISCStudyTrailDesignRow`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

//Import TMap CSV File
async function importStudyCDISCTrailDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}importStudyCDISCTrailDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Pull New CDISC Trail Design Row
async function pullCDISCStudyTrailDesignRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}pullCDISCStudyTrailDesignRow`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}


// Add New CDISC SDA
async function addNewCDISCSDA(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewCDISCSDA`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New CDISC SDA
async function addNewStudyCDISCSDA(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyCDISCSDA`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get CDISC Study Trail Design Row
async function getCDISCSDA(searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getCDISCSDA?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getCDISCSDA?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Download SDA Template
async function downloadSDATemplate() {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}downloadSDATemplate`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

//Import SDA CSV File
async function importSDACSVFile(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}importSDACSVFile`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get CDISC Study Trail Design Row
async function getStudyCDISCSDA(studyId, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyCDISCSDA/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyCDISCSDA/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

//Import TMap CSV File
async function importStudySDACSVFile(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}importStudySDACSVFile`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function getVersionsForPullData(status) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getVersionsForPullData/${status}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getVariableCommentIdsForPullData(status) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getVariableCommentIdsForPullData/${status}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getVariableMethodIdsForPullData(status) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getVariableMethodIdsForPullData/${status}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getClassForPullData(status, versionId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getClassForPullData/${status}/${versionId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getValueLevelVariablesList(domainId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getValueLevelVariablesList/${domainId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getWithoutValueLevelVariablesList(domainId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getWithoutValueLevelVariablesList/${domainId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getSDTMCodeListForPullData() {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getSDTMCodeListForPullData`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function deleteCDISCSDA (userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteCDISCSDA `,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function deleteStudyCDISCSDA (userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyCDISCSDA `,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New Domain
async function addNewDomain(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewDomain`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Domains List
async function getDomainData(status, classId, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getDomainsData/${status}/${classId}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getDomainsData/${status}/${classId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Update Version
async function updateDomains(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateDomains`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function updateCDISCSDA(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateCDISCSDA`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function updateStudyCDISCSDA(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyCDISCSDA`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Domain
async function softDeleteRestoreDomain(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreDomain`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New Domain
async function addNewCDISCStudyFinalDomain(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewCDISCStudyFinalDomain`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Domains List
async function getCDISCStudyFinalDomain(status, studyId, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getCDISCStudyFinalDomain/${status}/${studyId}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getCDISCStudyFinalDomain/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Pull CDISC Study Final Domain Data
async function pullCDISCStudyFinalDomainData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}pullCDISCStudyFinalDomainData`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Update Version
async function updateCDISCStudyFinalDomain(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateCDISCStudyFinalDomain`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Domain
async function softDeleteRestoreCDISCStudyFinalDomains(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreCDISCStudyFinalDomains`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New Domain
async function addNewCDISCFinalDomain(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewCDISCFinalDomain`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Domains List
async function getCDISCFinalDomain(status, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getCDISCFinalDomain/${status}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getCDISCFinalDomain/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

//Import TMap CSV File
async function importStudyFinalDomainCSVFile(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}importStudyFinalDomainCSVFile`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Download TMap Template
async function downloadFinalDomainTemplate() {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}downloadFinalDomainTemplate`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Update Version
async function updateCDISCFinalDomain(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateCDISCFinalDomain`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Domain
async function softDeleteRestoreCDISCFinalDomains(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreCDISCFinalDomains`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New Variable Method
async function addNewVariableMethodId(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewVariableMethodId`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Variable Method List
async function getVariableMethodIdsData(status, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getVariableMethodIdsData/${status}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getVariableMethodIdsData/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Update Variable Method
async function updateVariableMethodIds(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateVariableMethodIds`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Variable Method
async function softDeleteRestoreVariableMethodId(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreVariableMethodId`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New Variable Comment
async function addNewVariableCommentId(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewVariableCommentId`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Variable Comment List
async function getVariableCommentIdsData(status, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getVariableCommentIdsData/${status}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getVariableCommentIdsData/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Update Variable Comment
async function updateVariableCommentIds(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateVariableCommentIds`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Variable Comment
async function softDeleteRestoreVariableCommentId(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreVariableCommentId`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New Variable
async function addNewVariable(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewVariable`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Variable
async function getVariableData(status, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getVariablesData/${status}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getVariablesData/${status}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Update Variable
async function updateVariables(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateVariables`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Variable
async function softDeleteRestoreVariable(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreVariable`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Add New Value Level
async function addNewValueLevel(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewValueLevel`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get Value Level
async function getValueLevelsData(status, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getValueLevelsData/${status}?search=${
        searchData || ""
      }&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getValueLevelsData/${status}?search=${
        searchData || ""
      }`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Update Value Level
async function updateValueLevels(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateValueLevels`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Value Level
async function softDeleteRestoreValueLevel(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreValueLevel`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Run CDISC Final Code
async function runCDISCFinalCode(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}runCDISCFinalCode`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Output Library
async function getStudyCDISCOutputLibraryData(studyId, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyCDISCOutputLibraryData/${studyId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Delete Output Library
async function deleteStudyCDISCCMapsData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyCDISCCMapsData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}